import { Grid } from "@mui/material";
import FormTextField from "components/FormFields/FormTextField";
import React from "react";

const BatteryInformationInput = ({ fields }) => {
  const batteryInformation = fields?.batteryInformation;
  return (
    <Grid container spacing={2} className="mt-3">
      <Grid item xs={12} spacing={2}>
        <h2>Battery Information</h2>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormTextField
              fullWidth
              value={batteryInformation?.batteryLongevity || 0}
              label="Battery Longevity (months)"
              disabled={true}
            />
          </Grid>

          <Grid item xs={6}>
            <FormTextField
              fullWidth
              value={batteryInformation?.batteryRemainingPercentage || 0}
              label="Battery Percentage (%)"
              disabled={true}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BatteryInformationInput;
